const capitalizeFirstLetter = (name: string): string => {
  if (!name) return name;

  const firstChar = name[0];
  if (firstChar && firstChar.toLowerCase() !== firstChar.toUpperCase()) {
    return firstChar.toUpperCase() + name.slice(1);
  }

  return name;
};

export const getNativeLanguageName = (languageCode: string): string => {
  const normalizedCode = languageCode.toLowerCase().split("-")[0];

  if (typeof Intl !== "undefined" && Intl.DisplayNames) {
    const displayNames = new Intl.DisplayNames([normalizedCode], {
      type: "language",
    });
    const nativeName = displayNames.of(normalizedCode);
    return nativeName ? capitalizeFirstLetter(nativeName) : languageCode;
  }

  return languageCode;
};
